import React from 'react';
import { Link } from 'react-router-dom';

const EventBrellaFooter = () => (
  <footer className="eb-footer">
    <div className="wrap footer-inner">
      <div className="fbrand">
        <div className="seal" style={{ width: 26, height: 26 }}>
          <span style={{ fontSize: 10 }}>EB</span>
        </div>
        EVENTBRELLA — BY SEAMLESSLY
      </div>
      <div className="footer-links">
        <Link to="/roi">The Math</Link>
        <Link to="/fees">Fees</Link>
        <Link to="/platform">Platform</Link>
        <Link to="/what-you-get">What You Get</Link>
      </div>
    </div>
  </footer>
);

export default EventBrellaFooter;
